import state from "./moduleCompaniesManagementState";
import mutations from "./moduleCompaniesManagementMutations";
import actions from "./moduleCompaniesManagementActions";

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
